<template>
  <AccountBlock class="block" :action="true" @action="handleUpdateProfile">
    <template #title>
      <icon class="icon-click" name="clickMe" size="3.4rem" />Mon profil
    </template>
    <template #action>Modifier mon profil</template>
    <AccountBlockItem
      v-for="field in fieldsShown"
      :key="field.valueId"
      :label="field.label"
      :value="field.value"
    />
  </AccountBlock>
</template>
<script setup lang="ts">
const profile = useProfileStore();
const fieldsHidden = ['products', 'plans'];
const fieldsShown = computed(() => {
  return profile.fields.filter((field) => {
    const name = (field as any).name;
    if (!fieldsHidden.includes(name)) return true;
    return false;
  });
});
const handleUpdateProfile = () => {
  navigateTo('/mon-compte/modifier-mon-profil');
};
</script>
<style lang="scss" scoped>
.block {
  .icon-click {
    margin-right: 1.4rem;
    transition: transform 400ms $ease-out-back;
    color: var(--color_secondary);
  }
  @include pointer-desktop {
    &:hover,
    &:focus {
      .icon-click {
        transform: translateX(0.4rem);
      }
    }
    &.expanded {
      .icon-click {
        transform: translateX(0);
      }
    }
  }
}
</style>
